import { useState, useRef, useEffect } from 'react';
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useSelector, useDispatch } from 'react-redux';
import CompStuPrescribeDataFunc from "@/pcomponents/common/content/edu/comp_stu_prescribe/func/data_func";
import { useReactToPrint } from 'react-to-print';
import RightScrollFix from "@/pcomponents/common/content/list/right_scroll_fix";
import ManageButtonArea from "./area/manage_btns";
import TopInfoArea from "./area/top_info";
import WritePageArea from "./area/write_page";

function WirteOneArea(props: any) {
  let myProps = {
    is_update: false,
    info: {},
    closePopup: () => { },
    refreshData: (inData: any) => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  let default_info = {
    ...CompStuPrescribeDataFunc.default_info,
  };
  const [info, setInfo] = useState(myProps.info);
  const [isUpdate, setIsUpdate] = useState(myProps.is_update);
  const [is_write_mode, set_is_write_mode] = useState(false);
  const top_box_ref = useRef<any>(null);
  const printRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  useEffect(() => {
    if (myProps.is_update) {
      get_info_by_ajax({
        info: myProps.info
      });
      set_is_write_mode(false);
    } else {
      setInfo({
        ...default_info,
        a_ymd: DateFunc.get_date_format(new Date(), "Ymd"),
        a_seq: "",
        a_mcomp_seq: user.comp_seq,
        a_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
        a_write_mcomp_seq: user.comp_seq,
        a_write_mcomp_user_seq: user.user_seq,
        a_write_mcomp_name: user.corp_name,
        a_writer: user.user_name,
        a_state: "ready",
        a_title: "학습처방",
        a_check_content: "학습태도/성향/수학 영역별 진단테스트/수리 수행력",
        ...myProps.info,
      });
      set_is_write_mode(true);
    }
  }, [myProps.info.row_pri_val, myProps.is_update]);

  const get_info_by_ajax = (inData: any) => {
    let opt_obj = {
      info: {},
      ...inData
    };
    let tmp_info = opt_obj.info;
    if (strFunc.is_empty(tmp_info)) {
      alert("조회할 정보가 없습니다.");
      myProps.closePopup();
      return false;
    }
    if (strFunc.is_empty(tmp_info.row_pri_val)) {
      alert("조회할 정보의 고유값이 없습니다.");
      myProps.closePopup();
      return false;
    }

    let row_pri_val = tmp_info.row_pri_val;
    let form_json_data = {
      s_pri_arr: [row_pri_val],
      is_paging: "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/comp_prescribe/comp_stu_prescribe/list',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            setInfo({
              ...default_info,
              ...tmp_info,
              ...response.data["data"]["info_arr"][0],
            });
          } else {
            alert("조회된 정보가 없습니다.");
            myProps.closePopup();
          }
        } else {
          alert("조회 중 오류." + response.data["msg"]);
          myProps.closePopup();
        }
      });
  };

  const go_write_by_ajax = () => {
    let wrte_info = { ...info };

    if(strFunc.is_empty(wrte_info.a_date)){
      alert("날짜를 입력해주세요.");
      return false;
    }

    if (strFunc.is_empty(info.a_title)) {
      alert("제목을 입력해주세요.");
      return false;
    }

    if (strFunc.is_empty(info.a_stu_name)) {
      alert("학생 이름을 입력해주세요.");
      return false;
    }

    // let confirm_msg = "저장하시겠습니까?";
    // if (isUpdate) {
    //   confirm_msg = "수정하시겠습니까?";
    // }

    // if (confirm(confirm_msg) == false) {
    //   return false;
    // }

    if(isUpdate == false){
      wrte_info.a_ymd = strFunc.getNumber2(wrte_info.a_date);
      wrte_info.a_seq = "";
    }

    let form_json_data: any = {
      data_arr: [wrte_info],
    };
    if (isUpdate == false) {
      form_json_data.is_default_val = "1";
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/comp_prescribe/comp_stu_prescribe/write',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("저장되었습니다.");
          response.data["data"][0].row_pri_val = response.data["data"][0].a_ymd + "," + response.data["data"][0].a_seq;
          setIsUpdate(true);
          get_info_by_ajax({
            info: (response.data["data"][0])
          });
          myProps.refreshData({});
          //myProps.closePopup();
        } else {
          alert("저장 중 오류." + response.data["msg"]);
          myProps.closePopup();
        }
      });
  };

  const goPrint = () => {
    if (printRef.current) {
      handlePrint();
    }
  };

  return (
    <div className='a4page_wrap'>
      <div ref={top_box_ref} style={{ background: "#fff", zIndex: 99 }} >
        <ManageButtonArea
          go_write_by_ajax={go_write_by_ajax}
          is_write_mode={is_write_mode}
          set_is_write_mode={set_is_write_mode}
          goPrint={goPrint}
          closePopup={myProps.closePopup}
        ></ManageButtonArea>
      </div>

      <div className='mt-1' >
        <TopInfoArea
          info={info}
          setInfo={setInfo}
          is_write_mode={is_write_mode}
        ></TopInfoArea>
      </div>

      <div className='mt-1'>
        <WritePageArea
          info={info}
          setInfo={setInfo}
          is_write_mode={is_write_mode}
          printRef={printRef}
        ></WritePageArea>
      </div>

      <div className='mt-1'>
        <ManageButtonArea
          go_write_by_ajax={go_write_by_ajax}
          is_write_mode={is_write_mode}
          set_is_write_mode={set_is_write_mode}
          goPrint={goPrint}
          closePopup={myProps.closePopup}
        ></ManageButtonArea>
      </div>

      <RightScrollFix
        right_ref={top_box_ref}
        limit_scroll_top={290}
        height={"auto"}
      ></RightScrollFix>
    </div>
  );
};
export default WirteOneArea;